import { dealershipTypes } from '@/constants/dealershipTypes';

export const getOffersActiveTabKey = (userId) => `offers-active-tab-${userId}`;

export const getOffersViewModeKey = (userId) => `offers-view-mode-${userId}`;

export const OFFERS_VIEW_MODES = Object.freeze({
  LIST: 'list',
  TILE: 'tile',
});

export const OFFERS_TILE_BATCH_SIZE = 12;

// Inferred from API payloads (not documented): negotiations the seller declined carry offer_state 2
// and an empty status_badge_pills list.
export const OFFER_STATE_DECLINED = 2;

export const SELLING_DEALERSHIP_TYPES = new Set([
  dealershipTypes.franchise,
  dealershipTypes.acvCertifiedIndependent,
  dealershipTypes.commercial,
]);

export const offersNegotationsTableColumns = [
  {
    key: 'auctionId',
    label: 'Auction ID',
    sortable: true,
    filterable: false,
  },
  {
    key: 'yearMakeModel',
    label: 'Vehicle',
    sortable: true,
    filterable: false,
  },
  {
    key: 'endTime',
    label: 'Time Remaining',
    sortable: true,
    filterable: false,
  },
  {
    key: 'reservePrice',
    label: 'Reserve',
    sortable: true,
    filterable: false,
  },
  {
    key: 'acvEstimate',
    label: 'ACV Estimate',
    sortable: true,
    filterable: false,
  },
  {
    key: 'lastSent',
    label: 'Sent',
    sortable: true,
    filterable: false,
  },
  {
    key: 'lastReceived',
    label: 'Received',
    sortable: true,
    filterable: false,
  },
];

export default {
  offersNegotationsTableColumns,
};
